/* eslint-disable unicorn/filename-case */
import React, { useContext, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { useTranslator } from '@jutro/locale';
import styles from './WMICPendingPaymentCancellation.module.scss';
import messages from './WMICPendingPaymentCancellation.messages';
import { DateUtil } from 'wmic-portals-utils-js';

import { IntlContext } from '@jutro/legacy/locale';

const WMICPendingPaymentCancellationError = (props) => {
    const translator = useTranslator();
    const intl = useContext(IntlContext);
    const {
        payment
    } = props;

    const paymentDate = DateUtil.formatDateIntl(payment?.draftDate, intl);

    return (
        <Fragment>
            <p aria-hidden className={styles['wmic-pending-payment-paragraph']}>
                {translator(messages.AnErrorOccurredWhileProcessingYourRequest)}
            </p>
            <p className="sr-only">
                {
                    translator(messages.AnErrorOccurredWhileProcessingYourRequestAria, {
                        eventDate: paymentDate,
                        amount: payment?.transactionAmount?.amount
                    })
                }
            </p>
            <p aria-hidden className={styles['wmic-pending-payment-paragraph']}>
                <strong>
                    {paymentDate}
                </strong>
                <br />
                { translator(messages.OneTimeBankWithdrawal) }
                <br />
                { translator(messages.Amount) }
                <CurrencyField
                    id={`currencyAmountPendingPayment${payment?.processID}`}
                    value={payment?.transactionAmount}
                    dataType="object"
                    readOnly
                    hideLabel
                    className={styles['wmic-pending-payment-value']}
                />
            </p>
        </Fragment>
    );
};

WMICPendingPaymentCancellationError.propTypes = {
    payment: PropTypes.bool.isRequired
};

export default WMICPendingPaymentCancellationError;
